<ng-container *transloco="let t">
<div class="details-wrapper px-3 py-4">
    <div class="details-wrapper__item">
        <img src="assets/img/svg/distance.svg" [alt]="t('app.map.elevation.graph.distance.m')"/>
        <div>
            <p>
                {{t("app.map.elevation.graph.distance.m")}} </p>
            <p>
                {{race?.length | raceLengthFormat:translocoService.getActiveLang():"km"}} </p>
        </div>
    </div>
    <div class="details-wrapper__item">
        <img src="assets/img/svg/elevation_1.svg" [alt]="t('app.map.elevation.graph.elevation')"/>
        <div>
            <p>
                {{t("app.map.elevation.graph.elevation")}} </p>
            <p>
                {{race | raceAscentDescentFormat}} </p>
        </div>
    </div>
    <div class="details-wrapper__item">
        <img src="assets/img/svg/control-points.svg" [alt]="t('race.details.controlPoints')"/>
        <div>
            <p>
                {{t("race.details.controlPoints")}} </p>
            <p>
                {{race?.waypoints?.length ?? "-"}}
            </p>
        </div>
    </div>
    <div class="details-wrapper__item">
        <img src="assets/img/svg/feed-zones.svg" [alt]="t('race.details.feedZones')"/>
        <div>
            <p>
                {{t("race.details.feedZones")}} </p>
            <p>
                {{race?.refreshmentCheckpointAmount ?? "-"}} </p>
        </div>
    </div>
    <div class="details-wrapper__item">
        <img src="assets/img/svg/highest-alt.svg" [alt]="t('race.details.max.altitude.short')"/>
        <div>
            <p>
                {{t("race.details.max.altitude.short")}} </p>
            <p>
                {{race?.maxAltitude ? race?.maxAltitude + "m" : "-"}} </p>
        </div>
    </div>
    <div class="details-wrapper__item">
        <img src="assets/img/svg/lowest-alt.svg" [alt]="t('race.details.min.altitude.short')"/>
        <div>
            <p>
                {{t("race.details.min.altitude.short")}} </p>
            <p>
                {{race?.minAltitude ? race?.minAltitude + "m" : "-"}} </p>
        </div>
    </div>
    <div class="details-wrapper__item">
        <img src="assets/img/svg/max-participants.svg" [alt]="t('race.details.max.participants')"/>
        <div>
            <p>
                {{t("race.details.max.participants")}} </p>
            <p>
                {{race?.maxParticipants ?? "-"}} </p>
        </div>
    </div>
    <div class="details-wrapper__item">
        <img src="assets/img/svg/registered-participants.svg" [alt]="t('race.details.reg.participants')"/>
        <div>
            <p>
                {{t("race.details.reg.participants")}} </p>
            <p>
                {{race?.competitorCount?.total ?? "-"}} </p>
        </div>
    </div>
</div>
</ng-container>